// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__zumre","logo":"Navbar_logo__rU6F1","info":"Navbar_info__u04ec","infoTitle":"Navbar_infoTitle__bFKcb","time":"Navbar_time__8lLgV"};